import { useEffect, useState } from 'react';
import { useRouter } from '@abyss/web/hooks/useRouter';
import { UserService } from '@src/api/common/UserService';
import { useAuthSessionStore } from '@src/store/common/AuthSessionStore';

export const getInitials = (name: string): string => {
  //console.log(name);
  if (!name) return 'U';
  const parts = name.split(/[ ,]+/);
  //console.log("parts",parts);
  return parts
    .map((part) => part[0].toUpperCase())
    .slice(0, 2)
    .join('');
};

const HeaderController = () => {
  const { navigate } = useRouter();
  //const [user, setUser] = useState({ givenName: 'User', displayName: 'User' });
  const user = useAuthSessionStore((state) => state.identity);
  const isActorAdmin = useAuthSessionStore((state) => state.isAdmin);
  const syncFromCookies = useAuthSessionStore((state) => state.syncFromCookies);
  const [openLogout, setOpenLogout] = useState<boolean>(false);

  const Action = {
    Impersonation: async () => {
      navigate('/impersonation');
    },
    Logout: async () => {
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('userName');
      UserService.ClearAuthenticationCookies();
      navigate('/logout');
    },

    GoToNotifications: async () => {
      // Placeholder for notifications - developers can implement this
      //console.log('Navigate to notifications - implement as needed');
      navigate('/notifications');
    },
  };

  useEffect(() => {
    syncFromCookies();

    const handleFocus = () => {
      syncFromCookies();
    };
    const handleStorage = (event: StorageEvent) => {
      if (
        !event.key ||
        event.key === 'userName' ||
        event.key === 'isLoggedIn'
      ) {
        syncFromCookies();
      }
    };

    window.addEventListener('focus', handleFocus);
    window.addEventListener('storage', handleStorage);

    return () => {
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('storage', handleStorage);
    };
  }, []);

  return [
    {
      user,
      openLogout,
      setOpenLogout,
      isActorAdmin,
      Action,
    },
  ];
};

export { HeaderController };
